import * as yup from 'yup';

export const samplingScheduleSchema = yup.object({
    stationId: yup.number().required('Station ID is required'),
    scheduleType: yup.string().required('Schedule type is required'),
    intervalMinutes: yup.number().required('Interval minutes is required'),
    thresholdMin: yup.number().required('Threshold min is required'),
    thresholdMax: yup.number().required('Threshold max is required'),
    isActive: yup.boolean().required('Is active is required'),
    createdAt: yup.string().required('Created at is required'),
    lastRunAt: yup.string().required('Last run at is required'),
});                                                                                                                                         